import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA ,MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog'

@Component({
  selector: 'confirm-subscription',
  templateUrl: './confirm-subscription.component.html',
  styleUrls: ['./confirm-subscription.component.scss']
})
export class ConfirmSubscriptionComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmSubscriptionComponent>, 
  @Inject(MAT_DIALOG_DATA) public products: Date, private dialog: MatDialog) { }

  date: Date;
  ngOnInit() {
    this.date= this.products;
  }
  onClose() {
    this.dialogRef.close();
  }

}
